import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Card } from '@components/common/Card';
import { Button } from '@components/common/Button';
import { cn } from '@utils/cn';
const categories = [
    { value: 'all', label: '全部' },
    { value: 'sci-fi', label: '科幻' },
    { value: 'fantasy', label: '奇幻' },
    { value: 'drama', label: '剧情' },
    { value: 'adventure', label: '冒险' },
    { value: 'mystery', label: '悬疑' },
    { value: 'comedy', label: '喜剧' },
];
const genres = [
    { value: '科幻', label: '科幻' },
    { value: '奇幻', label: '奇幻' },
    { value: '剧情', label: '剧情' },
    { value: '悬疑', label: '悬疑' },
    { value: '冒险', label: '冒险' },
    { value: '喜剧', label: '喜剧' },
    { value: '情感', label: '情感' },
    { value: '治愈', label: '治愈' },
    { value: '哲学', label: '哲学' },
    { value: '惊悚', label: '惊悚' },
];
const durations = [
    { value: 'all', label: '不限' },
    { value: 'short', label: '短片 (<10分钟)' },
    { value: 'medium', label: '中片 (10-30分钟)' },
    { value: 'long', label: '长片 (>30分钟)' },
];
export function TopicFilter({ onFilterChange }) {
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [selectedGenres, setSelectedGenres] = useState([]);
    const [selectedDuration, setSelectedDuration] = useState('all');
    const handleCategoryChange = (value) => {
        setSelectedCategory(value);
        onFilterChange({
            category: value,
            genre: selectedGenres,
            duration: selectedDuration,
        });
    };
    const handleGenreToggle = (value) => {
        const newGenres = selectedGenres.includes(value)
            ? selectedGenres.filter((g) => g !== value)
            : [...selectedGenres, value];
        setSelectedGenres(newGenres);
        onFilterChange({
            category: selectedCategory,
            genre: newGenres,
            duration: selectedDuration,
        });
    };
    const handleDurationChange = (value) => {
        setSelectedDuration(value);
        onFilterChange({
            category: selectedCategory,
            genre: selectedGenres,
            duration: value,
        });
    };
    const handleReset = () => {
        setSelectedCategory('all');
        setSelectedGenres([]);
        setSelectedDuration('all');
        onFilterChange({
            category: 'all',
            genre: [],
            duration: 'all',
        });
    };
    return (_jsx(Card, { className: "sticky top-20", children: _jsxs("div", { className: "space-y-6", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsx("h3", { className: "font-semibold text-gray-100", children: "\u7B5B\u9009" }), _jsx(Button, { variant: "ghost", size: "sm", onClick: handleReset, children: "\u91CD\u7F6E" })] }), _jsxs("div", { children: [_jsx("h4", { className: "mb-3 text-sm font-medium text-gray-300", children: "\u7C7B\u578B" }), _jsx("div", { className: "space-y-2", children: categories.map((cat) => (_jsx("button", { onClick: () => handleCategoryChange(cat.value), className: cn('block w-full rounded-lg px-3 py-2 text-left text-sm transition-colors', selectedCategory === cat.value
                                    ? 'bg-primary-500/20 font-medium text-primary-400 border border-primary-500/50'
                                    : 'text-gray-400 hover:bg-dark-500 hover:text-gray-300'), children: cat.label }, cat.value))) })] }), _jsxs("div", { children: [_jsx("h4", { className: "mb-3 text-sm font-medium text-gray-300", children: "\u9898\u6750" }), _jsx("div", { className: "flex flex-wrap gap-2", children: genres.map((genre) => (_jsx("button", { onClick: () => handleGenreToggle(genre.value), className: cn('rounded-full px-3 py-1 text-sm transition-colors', selectedGenres.includes(genre.value)
                                    ? 'bg-secondary-500 text-white shadow-md'
                                    : 'bg-dark-500 text-gray-400 hover:bg-dark-400 hover:text-gray-300'), children: genre.label }, genre.value))) })] }), _jsxs("div", { children: [_jsx("h4", { className: "mb-3 text-sm font-medium text-gray-300", children: "\u65F6\u957F" }), _jsx("div", { className: "space-y-2", children: durations.map((dur) => (_jsxs("label", { className: "flex cursor-pointer items-center gap-2 text-sm text-gray-400 hover:text-gray-300", children: [_jsx("input", { type: "radio", name: "duration", value: dur.value, checked: selectedDuration === dur.value, onChange: () => handleDurationChange(dur.value), className: "text-primary-500 focus:ring-primary-500 bg-dark-500 border-gray-600" }), dur.label] }, dur.value))) })] })] }) }));
}
